import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content", "button", "text", "icon"]

  toggle() {
    if (!this.hasContentTarget) return

    const isExpanded = this.element.classList.contains('cc-expanded')

    if (isExpanded) {
      this.element.classList.remove('cc-expanded')
      this.contentTarget.classList.add('hidden')
      if (this.hasTextTarget && this.hasButtonTarget) {
        this.textTarget.textContent = this.buttonTarget.dataset.showLabel
      } else if (this.hasButtonTarget) {
        this.buttonTarget.textContent = this.buttonTarget.dataset.showLabel
      }
      if (this.hasIconTarget) {
        this.iconTarget.classList.remove('-rotate-180')
      }
    } else {
      this.element.classList.add('cc-expanded')
      this.contentTarget.classList.remove('hidden')
      if (this.hasTextTarget && this.hasButtonTarget) {
        this.textTarget.textContent = this.buttonTarget.dataset.hideLabel
      } else if (this.hasButtonTarget) {
        this.buttonTarget.textContent = this.buttonTarget.dataset.hideLabel
      }
      if (this.hasIconTarget) {
        this.iconTarget.classList.add('-rotate-180')
      }
    }
  }
} 